import { configureStore } from "@reduxjs/toolkit";
import auth from "./auth/authSlice";
import dashboard from "./dashboard/dashboard";
import defaultState from "./defaultSlice";
import employees from "./employee/employee";
import jobs from "./jobs/jobs";
import manualReassignment from "./jobs/manualReassignment";
import vendors from "./vendor/vendor";

export const store = configureStore({
  reducer: {
    defaultState,
    auth,
    jobs,
    vendors,
    employees,
    manualReassignment,
    dashboard,
  },
});
